// extracted by mini-css-extract-plugin
export default {"addonModalBody":"RemoveAddonModal_addonModalBody__MRzN6"};